import { SearchInput } from "@legacy/SearchInput";
import { getNestedValue } from "@utils/index";
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useReducer } from "react";

/**
 * @param {Object} props
 * @param {String} props.id id of first div
 * @param {Array} props.data list of item
 * @param {Array} props.filterKeys list of string for fields to filter, if not provide, will search  on each field of the item
 * @param {Function|Object} props.RenderList Component who render the list
 * @param {Object} props.RenderListProps Props for renderList
 * @param {Object} props.SearchInputProps Props for input search
 * @param {Function} props.onChange Return Total, length and list data
 * @param {Function} props.TitleComponent Title Component on the Top left corner
 */
export const ListSearch = (props) => {
  const {
    id,
    data = [],
    filterKeys,
    RenderList,
    RenderListProps,
    SearchInputProps,
    onChange,
    TitleComponent,
    ...rest
  } = props;

  const [state, setState] = useReducer((state, newState) => ({ ...state, ...newState }), {
    list: data,
    total: data.length || 0,
    filterValue: { value: "" },
  });

  useEffect(() => {
    if (Array.isArray(data)) {
      setState({ list: data });
    }
  }, [data]);

  useEffect(() => {
    if (Array.isArray(data) && data.length) {
      onFilter(state.filterValue, data);
    }
  }, [state.filterValue.value, data]);

  const onFilter = (value = { value: "" }, listToFilter = []) => {
    // get value of search field
    const filterValue = value.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    let filterList = [];
    if (!filterValue) {
      filterList = listToFilter;
    } else {
      // filter the state list to desplay
      filterList = listToFilter.filter((item) => {
        const fieldToFilter = filterKeys || Object.keys(item);
        // for each item of the list, find match with filterKeys field or each field
        return fieldToFilter.some((k) => {
          // exemple of nestedKey : 'candidate.lastName'
          const nestedKey = k.split(".");
          const fieldToSearch = getNestedValue(item, nestedKey);
          if (!fieldToSearch || typeof fieldToSearch !== "string") {
            return false;
          }
          return fieldToSearch
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .includes(
              filterValue
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
            );
        });
      });
    }

    setState({ list: filterList });
    if (typeof onChange === "function") {
      onChange({ total: filterList.length, list: filterList });
    }
  };

  return (
    <>
      {TitleComponent && <TitleComponent />}
      <SearchInput
        id={`${id}-input-search-list`}
        filterWrapper={{ search: "value" }}
        filter={state.filterValue}
        onFilter={(filter) => setState({ filterValue: filter })}
        delay={500}
        {...SearchInputProps}
      />
      <div id={`${id}-container-render-list`} {...rest}>
        <RenderList list={state.list} total={state.total} {...RenderListProps} />
      </div>
    </>
  );
};
